import { getContext } from '@picsart/miniapps-sdk';
import { PUBLISH_EVENT } from '../constants';

const T2BPackageId = 'ai-background';

const publishRegistrationEvent = async () => {
  const { publishEvent } = getContext().handlers;

  await publishEvent({
    event: PUBLISH_EVENT.REGISTRATION,
    data: {
      source: T2BPackageId,
      action: T2BPackageId,
    },
  });
};

export default publishRegistrationEvent;
